import { Tt as e } from "../../chunks/icons-BQHDHs7w.js";
import t from "react";
import { Fragment as n, jsx as r, jsxs as i } from "react/jsx-runtime";
import { trackEvent as a } from "@cx-web/utils/dataLayer";
var o = {
	articleHeader: "_articleHeader_18w6u_1",
	articleDetailsContainer: "_articleDetailsContainer_18w6u_15",
	articleSummary: "_articleSummary_18w6u_28",
	articleAuthor: "_articleAuthor_18w6u_36",
	articleHeroImage: "_articleHeroImage_18w6u_50",
	articleMetadata: "_articleMetadata_18w6u_64",
	lockedContentIcon: "_lockedContentIcon_18w6u_73",
	lockedContentButton: "_lockedContentButton_18w6u_92"
};
//#endregion
//#region page-template/ArticleHeader/getWebPImageUrlWithWidth.ts
function s(e, t) {
	try {
		let n = new URL(e);
		return n.searchParams.set("fm", "webp"), n.searchParams.set("w", String(t)), n.toString();
	} catch {
		return `${e}${e.includes("?") ? "&" : "?"}fm=webp&w=${t}`;
	}
}
//#endregion
//#region page-template/ArticleHeader/ArticleHeader.tsx
var c = ({ aiGeneratedId: c, authors: l, componentTags: u, description: d, image: f, imageWidth: p, isLoggedIn: m, onLogin: h, publishedTimeLocalised: g, readTime: _, title: v }) => {
	let y = l[0], b = u?.includes("TIPS_PREMIUM");
	return t.useEffect(() => {
		y && a("article_view", {
			tipsterName: y.fullName,
			articleName: v,
			isLocked: b ? "yes" : "no",
			aiArticle: c ? "yes" : "no"
		});
	}, [
		y,
		c,
		b,
		v
	]), y ? /* @__PURE__ */ i("header", {
		"aria-labelledby": "article-title",
		"data-testid": "article-header-container",
		children: [
			/* @__PURE__ */ r("picture", {
				className: o.articleHeroImage,
				children: /* @__PURE__ */ r("img", {
					alt: f.alt,
					className: "w-full h-full absolute object-cover object-top",
					"data-testid": "article-hero-image",
					src: s(f.url, p)
				})
			}),
			/* @__PURE__ */ r("h1", {
				className: o.articleHeader,
				"data-testid": "article-title",
				children: v
			}),
			/* @__PURE__ */ r("h2", {
				className: o.articleSummary,
				"data-testid": "article-subtitle",
				children: d
			}),
			b && /* @__PURE__ */ r("div", {
				className: o.lockedContentIcon,
				children: m ? /* @__PURE__ */ r(n, { children: "unlocked" }) : /* @__PURE__ */ i("button", {
					className: o.lockedContentButton,
					onClick: () => {
						a("article_header_login", {
							tipsterName: y.fullName,
							articleName: v
						}), h();
					},
					type: "button",
					children: ["log in to view for free", /* @__PURE__ */ r(e, {})]
				})
			}),
			/* @__PURE__ */ i("div", {
				className: o.articleDetailsContainer,
				children: [/* @__PURE__ */ i("p", {
					className: o.articleAuthor,
					"data-testid": "article-author-name",
					children: [y.fullName, g && ` - ${g}`]
				}), _ && /* @__PURE__ */ r("span", {
					className: o.articleMetadata,
					"data-testid": "article-metadata-read-time",
					children: _
				})]
			})
		]
	}) : null;
}, l = c;
//#endregion
export { c as ArticleHeader, l as default };
